import { useUser } from "../../../fetch/fetch.user.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_USER_PROFILE } from "../../../const/typeDefault/User.ts";
import Image from "../../core/image/Image";
import { IconUserFilled } from "@tabler/icons-react";

const UserImage = ({
  userId,
  sizes,
  className,
}: {
  userId: string;
  sizes?: string;
  className?: string;
}) => {
  // State to store any data fetched asynchronously (if needed)
  const { user, isError, isLoading } = useUser(userId, EMPTY_USER_PROFILE);
  if (isLoading) {
    return <div className={`skeleton ${className}`}></div>;
  }
  if (isError) {
    return <ErrMessage message={isError.message} />;
  }

  if (!user.avatarUrl) {
    return (
      <figure>
        <IconUserFilled className={className} />
      </figure>
    );
  }
  return (
    <Image
      src={user.avatarUrl}
      sizes={sizes}
      className={className}
      alt={`Foto von ${user.username}`}
    />
  );
};
export default UserImage;
